export const pageTitle = 'Login';
const  eraIcons  = require("../assets/icons/era_commons.svg");

export const loginProvidersData = {
  nih: {
    key: 'auth_url',
    icon: eraIcons,
    loginButtonText: 'eRA Commons',
  },
};

export const bentoHelpEmail = 'bento-help@nih.gov';

export default null;
